export enum RefundType {
    CashRefund = 1,
    AddedToDeposit = 2,
}
